import { WEBCHAT_SOURCE } from 'modules/webchat/domain/constants';
import { IMountWebchatDTO } from 'modules/webchat/domain/dtos';
import { TWebchatExtraParams } from 'modules/webchat/domain/entities';
import { IWebchatWidgetProvider } from 'modules/webchat/domain/providers';

export default class MountWebchatUseCase {
  constructor(private widgetProvider: IWebchatWidgetProvider) {}

  public execute({ settings, identity, language }: IMountWebchatDTO): void {
    const extraParams: TWebchatExtraParams = {
      identifier: identity.identifier,
      origem: WEBCHAT_SOURCE,
      idioma: language,
    };

    if (identity.customerId) {
      extraParams.idcliente = String(identity.customerId);
    }

    if (identity.name) extraParams.nome = identity.name;
    if (identity.phone) extraParams.telefone = identity.phone;
    if (identity.type) extraParams.tipo = identity.type;

    this.widgetProvider.mount(settings, extraParams);
  }
}
